import { createContext, useContext } from 'react';
import { useMobileSidebar } from '../../contexts/MobileSidebarContext';

interface AppLayoutContextValue {
  openUpgradeModal: () => void;
}

export const AppLayoutContext = createContext<AppLayoutContextValue | null>(null);

export function useAppLayout() {
  const context = useContext(AppLayoutContext);
  const mobileSidebar = useMobileSidebar();

  if (!context) {
    throw new Error('useAppLayout must be used within AppLayout');
  }

  return {
    ...context,
    setMobileMenuOpen: (open: boolean) => open ? mobileSidebar.open() : mobileSidebar.close(),
  };
}
